



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from '@/shared/utilities';
import DataTableComponents from "@/components/App/Assets/Card/Body/CardType/DataTable/SimpleDataTable.vue";
import AuthService from "@/services/auth.service";
import { Locales } from "@/i18n/locales";

const auth = new AuthService();
@Component({
  components: {
    DataTableComponents,
  },
})
export default class ExternalReviewerGrid extends Vue {
  @Action("resetAppState", { namespace: "application" }) resetAppState: any;
  @Action("setApplicationId", { namespace: "application" }) setApplication: any;
  @Action("getCategories", { namespace: "reviewForm" }) getCategories: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;
  @Prop() items!: any;
  @Prop() entity!: any;
  filterByKey = "";
  readonlyStatus = [
    _app.reviewStatus.COI_Rejected,
    _app.reviewStatus.Submitted,
  ];

  submittedStatus = _app.reviewStatus.Submitted;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  // data() {
  //   let payload = this.$store.state["externalReviewIndex"];
  //   payload.orgFields = payload.fields;
  //   payload.data = this.items;
  //   return payload;
  // }

  get appItems() {
    console.log(this.items)
    return this.items.map(x =>  { 
          x.TotalProjectBudget = x.TotalProjectBudget && !isNaN(x.TotalProjectBudget) ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale ) : typeof(x.TotalProjectBudget) === "string" ? x.TotalProjectBudget : null; 
          x.RequestedAmount = x.RequestedAmount && !isNaN(x.RequestedAmount) ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale ) : typeof(x.RequestedAmount) === "string" ? x.RequestedAmount : null; 
          return x;
        });
  }

  /*** data table options  */
  get options() {
    return {
      accessRights: this.checkBtnRights
    }
  }

  mounted() {
    let rootState = this.$store.state;
    let payload = this.$store.state.dashboard;
    let componentName = "externalReviewDashboardIndex";
    let header = [],
      totalFields,
      fieldsList = [];

    //#.Filter component enabled.
    if (payload.template.filter == true) {
      payload.cards.push("FilterComponent");
      payload.title.push("Filter");
    }

    // @ts-ignore
    _.forOwn(rootState[componentName].fields, function (key, val) {
      if (
        key.primaryKey != true &&
        key.parent != true &&
        key.list != false &&
        key.type != "Hidden"
      ) {
        if (!key.orgTitle) key.orgTitle = key.title;

        if (payload.keyTranslator) key.text = key.orgTitle;
        else key.text = key.title;

        key.title = key.text;
        // @ts-ignore
        header.push(key);
      }

      if (
        !key.primaryKey &&
        key.type != "Hidden" &&
        !key.create &&
        !key.parent
      ) {
        // @ts-ignore
        fieldsList.push(key.value);
      }
    });

    rootState[componentName].headers = header;

    // this.callProposalCallFilter("");

    // @ts-ignore
    this.$store.dispatch("load", this.$store.state["externalReviewDashboardIndex"]);
  }

  /** check the button rights */
  checkBtnRights(field: any, record: any) {
    switch(field.event){
      case 'edit':
        return !this.readonlyStatus.includes(record.ReviewStatusId);
        break;
      case 'download':
        return record.ReviewStatusId !== null ;
        break;
      case 'review':
        return this.submittedStatus == record.ReviewStatusId;
        break;
      default:
        return true;
    }
  }

  editApplication(data) {
   auth.getUser().then((user) => {
      if (user !== null) {
        this.$router.push({
          name: "reviewApplication",
          params: {
            reviewerId: user.profile.sub,
            applicationId: data.uniqueID,
            entity: this.entity
          }
        });
      }
    });
  }

  viewReview(data: any) {
    if (data !== null) {
        let routeData = this.$router.resolve({
          name: "viewTagReview",
          query: { reviewerId: data.ReviewerId,
          applicationId: data.uniqueID,
          entity: this.entity }
        });

        window.open(routeData.href, "_blank");
      }
  }

 downloadPdf(item: any) {
    let self = this;
    let categoryList = [],
      modelData,
      formData;
    if (item.ExternalReviewId) {
      //this.$services.review.getReportData(item.ExternalReviewId)
      this.$services.review
        .getReportData(item.ExternalReviewId, this.entity)
        .then((resp) => {
          if (resp.status >= 200 && resp.status < 300) {
            this.getCategories({ id: item.ApplicationId, entity: self.entity }).then((catg) => {
              self.$services.tagReviewReport.generate({
                data: resp.data.review,
                categories: catg,
                metadata: resp.data.metadata,
                user: self._username,
              });
            });
          }
        });
    }
  }

  deleteApplication(data) {
    const self = this;
  }
}
